import { PluginListenerHandle, registerPlugin } from '@capacitor/core';

export interface ShareInboxNativeFile {
  name: string;
  mimeType: string | null;
  size: number | null;
  path: string;
}

export interface ShareInboxNativePayload {
  id: string;
  createdAt: number;
  text: string | null;
  title: string | null;
  files: ShareInboxNativeFile[];
}

export interface ShareInboxLastTarget {
  chatId: number;
  sentAt: number;
}

export interface ShareInboxPlugin {
  getPendingShare(): Promise<{ payload: ShareInboxNativePayload | null }>;
  clearPendingShare(): Promise<void>;
  getLastShareTarget(): Promise<{ target: ShareInboxLastTarget | null }>;
  clearLastShareTarget(): Promise<void>;
  addListener(eventName: 'shareReceived', listenerFunc: (event: { payload?: ShareInboxNativePayload | null }) => void): Promise<PluginListenerHandle>;
}

const ShareInbox = registerPlugin<ShareInboxPlugin>('ShareInbox');

export default ShareInbox;
